import { BehaviorSubject } from "rxjs";

const subject = new BehaviorSubject<number>(0);

function GetSlideAngle(dx: number, dy: number) {
  return (Math.atan2(dy, dx) * 180) / Math.PI;
}

//根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
function GetSlideDirection(
  startX: number,
  startY: number,
  endX: number,
  endY: number
) {
  const dy = startY - endY;
  const dx = endX - startX;
  let result = 0;

  //如果滑动距离太短
  if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
    return result;
  }

  const angle = GetSlideAngle(dx, dy);
  if (angle >= -45 && angle < 45) {
    result = 4;
  } else if (angle >= 45 && angle < 135) {
    result = 1;
  } else if (angle >= -135 && angle < -45) {
    result = 2;
  } else if (
    (angle >= 135 && angle <= 180) ||
    (angle >= -180 && angle < -135)
  ) {
    result = 3;
  }

  return result;
}

//滑动处理
let startX: number, startY: number;
let endX: number, endY: number;

function thoshold(ev: Event) {
  const paths = ev.composedPath();
  const result = paths.reduce<boolean>((iter, now) => {
    const bailout =
      (now as HTMLElement).className?.indexOf("side-menu-drawer") > -1;
    if (bailout) {
      return false;
    }
    return iter;
  }, true);
  return !result;
}

document.body.addEventListener(
  "touchstart",
  function(ev) {
    if (thoshold(ev)) return;
    endX = 0;
    endY = 0;
    startX = ev.touches[0].pageX;
    startY = ev.touches[0].pageY;
  },
  false
);

let sid: number;

function emitDirection() {
  const direction = GetSlideDirection(startX, startY, endX, endY);
  switch (direction) {
    case 1:
      subject.next(1);
      break;
    case 2:
      subject.next(2);
      break;
    case 3:
      subject.next(3);
      break;
    case 4:
      subject.next(4);
      break;
    default:
  }
}

// document.body.addEventListener(
//   "touchmove",
//   function(ev) {
//     endX = ev.changedTouches[0].pageX;
//     endY = ev.changedTouches[0].pageY;
//     sid = window.setTimeout(() => {
//       emitDirection();
//     }, 300);
//   },
//   false
// );

document.body.addEventListener(
  "touchend",
  function(ev) {
    if (thoshold(ev)) return;
    endX = ev.changedTouches[0].pageX;
    endY = ev.changedTouches[0].pageY;
    if (sid) {
      window.clearTimeout(sid);
    }
    emitDirection();
  },
  false
);

export default subject;
